import React from 'react';
import nftBg from './assets/images/nft-bg.png';
import nft1 from './assets/images/nft-1.png';
import user1 from './assets/images/user-1.png';
import user2 from './assets/images/user-2.png';
import user3 from './assets/images/user-3.png';
import user4 from './assets/images/user-4.png';
import binanceCoin  from './assets/images/binance-coin.svg';
import { Splide, SplideSlide } from '@splidejs/react-splide';

const NFTs = () => {
    return (
        // <!-- NFTs -->
        <section id="nfts" className="nfts section">
          <div
            className="bg__holder"
            style={{ background: `url(${nftBg})`, backgroundSize: 'cover' }}
          ></div>
          {/* <!--// bg__holder --> */}
          <div className="container">
            <p className="section__para one" data-aos="fade-up">#NFT</p>
            <h2 className="heading__1" data-aos="fade-up">NFT Marketplace</h2>
            <p className="section__para two" data-aos="fade-up">
              Mint, Buy & Sell NFTs
            </p>
            <section
             
            >
              <div className="splide__track">
                <ul className="splide__list gap-1">
                <Splide
      options={ {
        rewind: true,
        width : 700,
        gap   : '1rem',
      } }
    className="mx-auto">
                  <li className="splide__slide">
                 
                  <div className="card    ">
                    <div className="card" data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={nft1}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user1}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Nft Collection</p>
                        </div>
                        <div className="block">
                          <p className="text">Gains:</p>
                          <div className="percentage">+99.99%</div>
                        </div>
                        <div className="block">
                          <p className="text">Floor Price:</p>
                          <div className="count">
                            <span className="icon">
                              <img
                                src={binanceCoin}
                                alt="binance-coin"
                                className="img-fluid"
                                width="20"
                                height="20"
                              />
                            </span>
                            0.5
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card     " data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={nft1}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user2}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Nft Collection</p>
                        </div>
                        <div className="block">
                          <p className="text">Gains:</p>
                          <div className="percentage">+49.98%</div>
                        </div>
                        <div className="block">
                          <p className="text">Floor Price:</p>
                          <div className="count">
                            <span className="icon">
                              <img
                                src={binanceCoin}
                                alt="binance-coin"
                                className="img-fluid"
                                width="20"
                                height="20"
                              />
                            </span>
                            0.5
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card    " data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={nft1}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user3}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Nft Collection</p>
                        </div>
                        <div className="block">
                          <p className="text">Gains:</p>
                          <div className="percentage">+39.98%</div>
                        </div>
                        <div className="block">
                          <p className="text">Floor Price:</p>
                          <div className="count">
                            <span className="icon">
                              <img
                                src={binanceCoin}
                                alt="binance-coin"
                                className="img-fluid"
                                width="20"
                                height="20"
                              />
                            </span>
                            0.5
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="splide__slide">
                    <div className="card    " data-aos="fade-up">
                      <a href="#" className="strech__link"></a>
                      <div className="card-img-top">
                        <img
                          src={nft1}
                          alt="Streamer"
                          width="397"
                          height="264"
                          className="img-fluid"
                        />
                      </div>
                      <div className="card-body">
                        <div className="user">
                          <span className="user__icon">
                            <img
                              src={user4}
                              alt="user"
                              width="90"
                              height="135"
                              className="img-fluid"
                            />
                          </span>
                          <p className="streamer__tag">Nft Collection</p>
                        </div>
                        <div className="block">
                          <p className="text">Gains:</p>
                          <div className="percentage">+29.99%</div>
                        </div>
                        <div className="block">
                          <p className="text">Floor Price:</p>
                          <div className="count">
                            <span className="icon">
                              <img
                                src={binanceCoin}
                                alt="binance-coin"
                                className="img-fluid"
                                width="20"
                                height="20"
                              />
                            </span>
                            0.5
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  </Splide>
                </ul>
              </div>
            </section>
            <div className="load-more">
              <a href="#" className="you-btn">Browse</a>
            </div>
          </div>
        </section>
        // <!-- NFTs -->
    );
};

export default NFTs;